<template>
  <div class="d logP">
    <l-header :name="'登录'"></l-header>
    <ul class="u u_log">
      <li>
        <label><i class="iC i_zh"></i>账号</label>
        <input
          type="text"
          v-model="username"
          class="l_inp"
          placeholder="请使用组织分配的用户名"
        />
      </li>
      <li class="pass_w">
        <label><i class="iC i_mm"></i>密码</label>
        <input
          :type="pwTxt"
          class="l_inp2"
          v-model="password"
          placeholder="请输入您的密码"
        />
        <van-icon
          size="20"
          :name="showEyeTxt"
          @click="showPassword"
          style="margin-right: 2px"
        />
      </li>
      <li class="forgetpw">
        <p class="a_wjmm" @click="forget()">忘记密码？</p>
      </li>
      <li class="huakuai">
        <Captcha
          ref="captchaRef"
          @success="handleCaptchaSuccess"
          @fail="handleCaptchaFail"
        />
      </li>
    </ul>

    <button id="button" class="btn btn_dl" @click="onSubmit">登录</button>
  </div>
</template>

<script>
import { reactive, toRefs, ref } from "vue";
import { useRouter } from "vue-router";
import lHeader from "@/components/LoginHeader";
import { login } from "@/service/user";
import { setLocal } from "@/common/js";
import { Toast } from "vant";
import Captcha from "@/components/Captcha.vue";
window.AliyunCaptchaConfig = {
  region: "cn",
  prefix: "6bco1p",
};

export default {
  setup() {
    const router = useRouter();
    let captcha = null;
    const captchaRef = ref(null);

    const state = reactive({
      username: "",
      password: "",
      showEyeTxt: "eye-o",
      pwTxt: "password",
    });

    const showPassword = () => {
      state.showEyeTxt = state.showEyeTxt === "eye-o" ? "closed-eye" : "eye-o";
      state.pwTxt = state.pwTxt === "password" ? "text" : "password";
    };

    const forget = () => {
      router.push({ path: `/forgetPassword` });
    };
    const handleCaptchaSuccess = async (e) => {
      captcha = e;
      try {
        const { username, password } = state;
        const { data } = await login({
          username: username,
          password: password,
          captchaToken: captcha,
        });
        if (data && data.accessToken) {
          const {
            accessToken = "",
            roleId = "",
            modifyPwd = "",
            school = "",
            profileExists = false,
          } = data;

          const { province = "", city = "", district = "" } = data;
          let area = "";
          if (province) {
            area += province;
          }
          if (city) {
            area += city;
          }
          if (district) {
            area += district;
          }
          setLocal("dsj_area", area);
          setLocal("dsj_accessToken", accessToken);
          setLocal("dsj_roleId", roleId);
          setLocal("dsj_modifyPwd", modifyPwd);
          setLocal("dsj_profileExists", profileExists);

          if (school != null && school != "") {
            setLocal("dsj_school", school);
          }

          // 需要刷新页面，否则 axios.js 文件里的 token 不会被重置
          window.location.href = "/";
        }
      } catch (error) {
        console.log("onSubmit error ->", error);
        const { message = "" } = error;
        if(message) {
          Toast.fail(message);
        } else {
           Toast.fail("登录失败请重试");
        }
      }
    };
    const handleCaptchaFail = (e) => {
      console.log("handleCaptchaFail--", e);
      // captcha = null;
    };
    // 提交登录或注册表单
    const onSubmit = async () => {
      const { username, password } = state;

      if (username == "") {
        Toast.fail("请输入您的账号");
        captchaRef.value?.initCaptcha();
        return false;
      }
      if (password == "") {
        Toast.fail("请输入您的密码");
        captchaRef.value?.initCaptcha();
        return false;
      }
      // 显示滑块验证码
      captchaRef.value?.show();
    };
    return {
      ...toRefs(state),
      captchaRef,
      onSubmit,
      forget,
      showPassword,
      handleCaptchaSuccess,
      handleCaptchaFail,
    };
  },
  components: {
    lHeader,
    Captcha,
  },
};
</script>

<style lang="less" scoped>
@import "../../common/style/mixin";
.pass_w {
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.forgetpw {
  border: none;
  min-height: 0.5rem;
  padding: 0;
  margin-top: 0.1rem;
}
.huakuai {
  padding: 0;
}
.nc-container .nc_scale .btn_ok,
.nc-container .nc_scale .nc_ok,
.nc-container .nc_scale .nc_bg {
  color: #ff7273 !important;
}
.nc-container #nc_1_wrapper {
  margin: 0 auto !important;
}
</style>
